<template>
    <div class="reputation-calculator">
        <div class="tool-tip">因110级之后智慧每天只能吃500颗，成本较高不推荐，建议每天做会长跟凯奇任务即可。</div>
        <div class="calculator-container">
            <div class="calculator-form">
                <el-form :model="reputationForm" :rules="reputationRules" ref="reputationFormRef" label-width="120px">
                    <el-form-item label="开始等级" prop="startLevel">
                        <el-input-number v-model="reputationForm.startLevel" :min="1" :max="110"
                            controls-position="right" style="width: 220px" />
                    </el-form-item>
                    <el-form-item label="结束等级" prop="endLevel">
                        <el-input-number v-model="reputationForm.endLevel" :min="1" :max="110" controls-position="right"
                            style="width: 220px" />
                    </el-form-item>
                    <el-form-item label="智慧一元" prop="pricePerUnit">
                        <div class="price-input">
                            <el-input-number v-model="reputationForm.pricePerUnit" :min="1" controls-position="right"
                                placeholder="输入智慧数量" style="width: 220px" />
                            <span class="price-suffix">颗</span>
                        </div>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" @click="calculateReputation" style="width: 220px">
                            计算
                        </el-button>
                    </el-form-item>
                </el-form>
            </div>

            <div v-if="calculationResult" class="calculation-result">
                <div class="results-header">
                    <h3>计算结果</h3>
                </div>
                <div class="results-content">
                    <el-descriptions :column="1" border>
                        <el-descriptions-item label="所需智慧">
                            {{ calculationResult.totalWisdom }} 颗
                        </el-descriptions-item>
                        <el-descriptions-item label="所需金额">
                            {{ calculationResult.totalPrice }} 元
                        </el-descriptions-item>
                    </el-descriptions>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { ref, reactive } from 'vue'
import { ElMessage } from 'element-plus'

export default {
    name: 'ReputationCalculator',
    setup() {
        const reputationFormRef = ref(null);
        const reputationForm = reactive({
            startLevel: 1,
            endLevel: 1,
            pricePerUnit: 1
        });

        const calculationResult = ref(null);

        const experienceData = [240, 480, 720, 1200, 2649, 3370, 4194, 5015, 5839, 5068, 5891, 6713, 7536, 8358, 7588, 8411, 9233, 10056, 10879,
            11800, 14256, 16632, 19008, 21384, 16632, 19008, 21384, 23760, 26136, 21384, 23760, 26136, 28512, 30888, 26136,
            28512, 30888, 33264, 35640, 82800, 99360, 115920, 132480, 149040, 115920, 132480, 149040, 165600, 182160, 149040,
            165600, 182160, 198720, 215280, 182160, 198720, 215280, 231804, 248400, 375552, 432576, 489600, 546624, 603648,
            433152, 490176, 547200, 604224, 661248, 490752, 547776, 604800, 661824, 718848, 548352, 605376, 662400, 719424,
            776448, 1564800, 1802400, 2040000, 2277600, 2515200, 1804800, 2042400, 2040000, 2517600, 2755100, 2044800, 2282400,
            2520000, 2757600, 2995200, 2284800, 2522400, 2760000, 2997600, 3235200, 2400000, 2600000, 2800000, 2900000, 3000000,
            3200000, 3400000, 3600000, 3800000, 4100000];

        const validateStartLevel = (rule, value, callback) => {
            if (value < 1 || value > 110) {
                callback(new Error('等级必须在1-110之间'));
            } else if (reputationForm.endLevel && value > reputationForm.endLevel) {
                callback(new Error('开始等级不能大于结束等级'));
            } else {
                callback();
            }
        };

        const validateEndLevel = (rule, value, callback) => {
            if (value < 1 || value > 110) {
                callback(new Error('等级必须在1-110之间'));
            } else if (reputationForm.startLevel && value < reputationForm.startLevel) {
                callback(new Error('结束等级不能小于开始等级'));
            } else {
                callback();
            }
        };

        const reputationRules = {
            startLevel: [
                { required: true, message: '请输入开始等级', trigger: 'change' },
                { validator: validateStartLevel, trigger: 'change' }
            ],
            endLevel: [
                { required: true, message: '请输入结束等级', trigger: 'change' },
                { validator: validateEndLevel, trigger: 'change' }
            ],
            pricePerUnit: [
                { required: true, message: '请输入智慧单价', trigger: 'change' },
                { type: 'number', min: 1, message: '单价必须大于0', trigger: 'change' }
            ]
        };

        const calculateReputation = () => {
            if (reputationForm.startLevel < 1 || reputationForm.startLevel > 110 ||
                reputationForm.endLevel < 1 || reputationForm.endLevel > 110 ||
                reputationForm.startLevel > reputationForm.endLevel ||
                reputationForm.pricePerUnit < 1) {
                ElMessage.error('请检查输入值是否正确');
                return;
            }

            let totalExperience = 0;
            for (let i = reputationForm.startLevel - 1; i < reputationForm.endLevel - 1; i++) {
                totalExperience += experienceData[i];
            }

            const totalWisdom = Math.ceil(totalExperience / 2000);
            const totalPrice = (totalWisdom / reputationForm.pricePerUnit).toFixed(2);

            calculationResult.value = {
                totalWisdom,
                totalPrice
            };
        };

        return {
            reputationForm,
            reputationRules,
            calculationResult,
            reputationFormRef,
            calculateReputation
        };
    }
}
</script>

<style scoped>
.reputation-calculator {
    display: flex;
    flex-direction: column;
    gap: 16px;
    width: 100%;
}

.tool-tip {
    font-size: 14px;
    color: #666;
    margin: 0;
    padding: 12px;
    background-color: #f5f7fa;
    border-radius: 4px;
    border-left: 4px solid #409eff;
}

.calculator-container {
    display: flex;
    flex-direction: row;
    gap: 24px;
    width: 100%;
    margin-top: 16px;
}



.calculation-result {
    flex: 1;
    padding: 20px;
    background: var(--el-bg-color-page);
    border-radius: 8px;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    min-width: 300px;
}

.results-header {
    margin-bottom: 16px;
}

.results-header h3 {
    margin: 0;
    font-size: 18px;
    color: var(--el-text-color-primary);
}

.results-content {
    background: var(--el-bg-color);
    padding: 16px;
    border-radius: 8px;
}

.price-input {
    display: flex;
    align-items: center;
    gap: 8px;
}

.price-suffix {
    color: var(--el-text-color-regular);
}

:deep(.el-form) {
    display: flex;
    flex-direction: column;
    gap: 20px;
}

:deep(.el-form-item) {
    margin-bottom: 0;
}

:deep(.el-descriptions) {
    padding: 24px;
    background: var(--el-bg-color);
    border-radius: 8px;
}

:deep(.el-descriptions__label) {
    width: 120px;
    justify-content: flex-start;
    font-size: 16px;
    color: var(--el-text-color-regular);
    padding: 20px 12px;
}

:deep(.el-descriptions__content) {
    font-size: 24px;
    font-weight: 500;
    color: var(--el-text-color-primary);
    padding: 20px 12px;
}

:deep(.el-descriptions__body) {
    background-color: transparent;
}

:deep(.el-descriptions__cell) {
    padding: 16px 0;
}

@media (max-width: 768px) {
    .calculator-container {
        flex-direction: column;
    }

    .calculator-form {
        min-width: unset;
    }

    .calculator-form :deep(.el-form-item) {
        margin-bottom: 18px;
    }

    .calculator-form :deep(.el-input-number) {
        width: 100% !important;
    }

    .calculator-form :deep(.el-button) {
        width: 100% !important;
    }

    .calculation-result {
        width: 100%;
    }
}
</style>